import httpClient from '@/http-client'

export const visitation = data => {
  return httpClient
    .post('/api/v1/reports/sale/visitation-plans', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const visitationExcel = data => {
  return httpClient
    .post('/api/v1/reports/sale/visitation-plans/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const user = (Options = {})  => {
  return httpClient
    .get('/api/v1/reports/sale/visitation-plans/users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
    visitation,
    visitationExcel,
    user
}